import { AgTechButtonProps, AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons';
import AgTechTourHelpButton from '@agtech/web/components/App/Tour/AgTechTourHelpButton';
import { BidderSelectionViewDialogTourConfig } from './BidderSelectionViewDialogTourConfig';
import { useCurrentSale } from '@sales/data/sales/SaleDataStore';
import React from 'react'
import SaleBidderRegistrationSelectionGrid from '../components/grids/BidderRegistrationSelectionGrid';
import AgTechViewDialog from '@agtech/web/components/Portals/Dialogs/AgTechViewDialog';
import { useAgTechWebAppContext } from '@agtech/web/components/App/Contexts/AgTechWebAppContext';

const BidderSelectionViewDialog = () => {
    let currentSale = useCurrentSale();

    return (
        <AgTechViewDialog
            structure={{
                header: () => ({
                    header: `Register Bidders - ${currentSale.saleName}`,
                    detail: "To register bidders for this sale, enter a bidder number for the contacts below",
                    settings: {
                        content: {
                            body: () => <AgTechTourHelpButton tourConfig={BidderSelectionViewDialogTourConfig} />
                        }
                    }
                }),
                width: '1200px'
            }}
        >
            {() => (
                <div id='bidder-selection-grid' className='stretched p-body flex'>
                    <SaleBidderRegistrationSelectionGrid />
                </div>
            )}
        </AgTechViewDialog>
    )
};

BidderSelectionViewDialog.Button = (props: AgTechButtonProps) => {
    const appContext = useAgTechWebAppContext();

    return (
        <AgTechButton
            text={props.text ?? 'Register bidders'}
            icon={props.icon ?? 'bi bi-card-checklist'}
            {...props}
            action={() => {
                appContext.dialogs.openDialog({
                    dialog: () => <BidderSelectionViewDialog />
                })
            }}
        />
    )
}

export default BidderSelectionViewDialog;